import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQuickCalculatorStep4 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 319 187",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0)",
			children: [
				/* @__PURE__ */ _jsxs("g", {
					clipPath: "url(#clip1)",
					children: [
						/* @__PURE__ */ _jsx("path", {
							d: "M313.03 179.695C313.268 178.646 313.507 177.596 313.507 176.547C313.507 170.157 308.733 164.815 302.407 163.957C300.974 156.422 294.768 150.794 287.367 150.794C279.967 150.794 273.76 156.422 272.328 163.861C272.089 163.861 271.97 163.861 271.731 163.861C265.524 163.861 260.511 169.203 260.511 175.88C260.511 177.215 260.75 178.55 261.108 179.79H313.03V179.695Z",
							fill: "#E0E0E0"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M71.6333 86.9832H35.915V93.8507H71.6333V86.9832Z",
							fill: "#E0E0E0"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M187.074 98.8107H70.8711V34.3322L187.074 66.5715V98.8107Z",
							fill: "#EBEBEB"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M271.56 174.354H44.3921V169.012H49.8213L46.8686 106.918H44.3921V92.8016L294.229 52.9318L271.56 174.354Z",
							fill: "#F5F5F5"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M195.647 69.5283V174.354H272.703L294.229 52.9318L195.647 69.5283Z",
							fill: "#EBEBEB"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M290.133 75.9188L289.752 78.1126H195.647V75.9188H290.133Z",
							fill: "#E0E0E0"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M288.038 88.0324L287.657 90.1308H195.647V88.0324H288.038Z",
							fill: "#E0E0E0"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M285.847 100.05L285.466 102.149H195.647V100.05H285.847Z",
							fill: "#E0E0E0"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M283.752 112.069L283.371 114.167H195.647V112.069H283.752Z",
							fill: "#E0E0E0"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M281.656 124.087L281.275 126.185H195.647V124.087H281.656Z",
							fill: "#E0E0E0"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M279.465 136.105L279.084 138.204H195.647V136.105H279.465Z",
							fill: "#E0E0E0"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M277.37 148.123L276.989 150.317H195.647V148.123H277.37Z",
							fill: "#E0E0E0"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M275.275 160.141L274.894 162.335H195.647V160.141H275.275Z",
							fill: "#E0E0E0"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M273.084 172.16L272.703 174.353H195.647V172.16H273.084Z",
							fill: "#E0E0E0"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M292.039 65.5222L291.658 67.6206H206.505L219.364 65.5222H292.039Z",
							fill: "#E0E0E0"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M293.848 54.9346L293.467 57.1284H269.083L282.037 54.9346H293.848Z",
							fill: "#47385B"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M307.619 46.6016L34.0999 93.3358L35.5898 102.08L309.109 55.3462L307.619 46.6016Z",
							fill: "#E0E0E0"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M194.313 71.8174L60.9653 34.9044L62.7751 28.4184L198.409 65.9991L194.313 71.8174Z",
							fill: "#E0E0E0"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M70.8712 75.4419H33.0575C32.486 75.4419 31.9146 74.965 31.9146 74.2973C31.9146 73.725 32.3908 73.1527 33.0575 73.1527H70.8712V75.4419Z",
							fill: "#E0E0E0"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M38.0105 74.2974H36.4866V87.7463H38.0105V74.2974Z",
							fill: "#E0E0E0"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M43.4395 74.2974H41.9155V87.7463H43.4395V74.2974Z",
							fill: "#E0E0E0"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M49.0591 74.2974H47.5352V87.7463H49.0591V74.2974Z",
							fill: "#E0E0E0"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M54.8694 74.2974H53.3455V87.7463H54.8694V74.2974Z",
							fill: "#E0E0E0"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M60.9651 74.2974H59.4412V87.7463H60.9651V74.2974Z",
							fill: "#E0E0E0"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M66.2991 74.2974H64.7751V87.7463H66.2991V74.2974Z",
							fill: "#E0E0E0"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M251.272 80.6881H223.841V145.644H251.272V80.6881Z",
							fill: "#F5F5F5"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M233.556 85.3618H251.272V80.6881H223.841V145.644H233.556V85.3618Z",
							fill: "#EBEBEB"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M222.602 79.6389V146.597H237.461H238.414H252.51V79.6389H222.602ZM250.034 99.0015H238.414V81.6419H250.034V99.0015ZM238.414 99.7645H250.034V116.743H238.414V99.7645ZM237.461 81.6419V99.0015H225.079V81.6419H237.461ZM237.461 116.743H225.079V99.7645H237.461V116.743ZM225.079 144.594V117.506H237.461V144.499H225.079V144.594ZM238.414 144.594V117.506H250.034V144.499H238.414V144.594Z",
							fill: "#E0E0E0"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M138.974 169.012H46.4876L44.3921 106.918H138.974V169.012Z",
							fill: "#E0E0E0"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M135.64 108.54V167.486H46.3925L44.4875 108.54H135.64Z",
							fill: "#F5F5F5"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M44.4875 108.54L44.7733 118.555L125.735 118.746V167.486H135.64V108.54H44.4875Z",
							fill: "#EBEBEB"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M44.7729 118.459H57.822V108.254H59.4412V118.459H75.2525V108.254H76.967V118.459H90.8733V108.254H92.4925V118.459H105.923V108.254H107.637V118.269L120.591 118.459V108.254H122.305V118.459H135.64H136.593V119.604H135.64H122.305V167.581L120.591 167.677V119.604H107.637V167.581L105.923 167.677V119.604H92.4925V167.772H90.8733V119.604H76.967V167.868H75.2525V119.604H59.4412V167.772H57.822V119.604H44.8682L44.7729 118.459Z",
							fill: "#E0E0E0"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M115.257 51.8826H73.7288V63.9008H115.257V51.8826Z",
							fill: "#F5F5F5"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M77.0625 55.221H115.257V51.8826H73.7288V63.9008H77.0625V55.221Z",
							fill: "#EBEBEB"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M73.2524 51.4056V64.3776H115.733V51.4056H73.2524ZM87.0635 63.4238H74.2049V52.3595H87.0635V63.4238ZM102.017 63.4238H88.016V52.3595H102.113V63.4238H102.017ZM114.781 63.4238H103.065V52.3595H114.781V63.4238Z",
							fill: "#E0E0E0"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M186.979 116.552H162.881V174.353H186.979V116.552Z",
							fill: "#E0E0E0"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M183.36 116.552H162.881V174.353H183.36V116.552Z",
							fill: "#EBEBEB"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M166.501 148.123C167.237 148.123 167.834 147.526 167.834 146.788C167.834 146.051 167.237 145.453 166.501 145.453C165.764 145.453 165.167 146.051 165.167 146.788C165.167 147.526 165.764 148.123 166.501 148.123Z",
							fill: "#E0E0E0"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M174.978 113.023C177.608 113.023 179.74 110.887 179.74 108.254C179.74 105.62 177.608 103.484 174.978 103.484C172.348 103.484 170.215 105.62 170.215 108.254C170.215 110.887 172.348 113.023 174.978 113.023Z",
							fill: "#E0E0E0"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M56.0405 179.574C56.2825 178.968 56.2825 178.241 56.2825 177.635C56.2825 173.636 52.8943 170.364 48.417 169.758C47.4489 165.154 42.9717 161.639 37.7684 161.639C32.5651 161.639 28.0878 165.154 27.1198 169.758C26.9987 169.758 26.8777 169.758 26.7567 169.758C22.2795 169.758 18.7703 173.151 18.7703 177.271C18.7703 178.12 18.8913 178.968 19.2543 179.695H56.0405V179.574Z",
							fill: "#E0E0E0"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M304.633 174.353H26.5186V179.79H304.633V174.353Z",
							fill: "#E0E0E0"
						})
					]
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M41.5381 145.961L44.5853 167.456L44.8875 169.606H46.8427L46.5363 167.456L43.489 145.961H41.5381Z",
					fill: "#FFBF1A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M93.4114 145.961L96.4586 167.456L96.7608 169.606H98.716L98.4095 167.456L95.3623 145.961H93.4114Z",
					fill: "#FFBF1A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M52.7766 167.456L53.0831 169.606L54.7275 181.195H56.6828L55.0383 169.606L54.7362 167.456H52.7766Z",
					fill: "#FFBF1A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M109.114 167.456L109.42 169.606L111.061 181.195H113.012L111.371 169.606L111.069 167.456H109.114Z",
					fill: "#FFBF1A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M99.2467 167.456L98.9403 169.606L97.2958 181.195H95.3406L96.9851 169.606L97.2872 167.456H99.2467Z",
					fill: "#FFBF1A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M42.9095 167.456L42.6031 169.606L40.9629 181.195H39.012L40.6521 169.606L40.9586 167.456H42.9095Z",
					fill: "#FFBF1A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M38.7284 148.953H96.3593L94.6975 142.966H37.0667L38.7284 148.953Z",
					fill: "#FFE511"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M39.9759 156.415H97.6068L95.9451 150.433H38.3099L39.9759 156.415Z",
					fill: "#FFE511"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M41.2189 163.891H98.8541L97.1923 157.909H39.5571L41.2189 163.891Z",
					fill: "#FFE511"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M40.7699 148.953H98.4051L96.7434 142.966H39.1082L40.7699 148.953Z",
					fill: "#fad504"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M42.0173 156.415H99.6482L97.9865 150.433H40.3556L42.0173 156.415Z",
					fill: "#fad504"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M43.2648 163.891H100.896L99.2339 157.909H41.603L43.2648 163.891Z",
					fill: "#fad504"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M112.209 167.456H51.8022V169.606H112.209V167.456Z",
					fill: "#fad504"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M51.8022 167.456H39.5571V169.606H51.8022V167.456Z",
					fill: "#FFE511"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M166.243 45.0278H267.857C268.366 45.0213 268.87 45.1205 269.338 45.3192C269.805 45.5179 270.227 45.8117 270.575 46.182C270.923 46.5522 271.191 46.9909 271.36 47.47C271.53 47.9492 271.598 48.4584 271.56 48.9653L263.272 182.475C263.192 183.535 262.718 184.528 261.944 185.258C261.17 185.987 260.151 186.401 259.088 186.418H157.467C156.959 186.419 156.457 186.316 155.992 186.115C155.526 185.914 155.107 185.62 154.759 185.25C154.412 184.88 154.145 184.443 153.973 183.966C153.802 183.488 153.731 182.981 153.764 182.475L162.046 48.9653C162.129 47.904 162.605 46.912 163.382 46.1836C164.158 45.4552 165.178 45.043 166.243 45.0278Z",
					fill: "#407BFF"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .4,
					d: "M166.243 45.0278H267.857C268.366 45.0213 268.87 45.1205 269.338 45.3192C269.805 45.5179 270.227 45.8117 270.575 46.182C270.923 46.5522 271.191 46.9909 271.36 47.47C271.53 47.9492 271.598 48.4584 271.56 48.9653L263.272 182.475C263.192 183.535 262.718 184.528 261.944 185.258C261.17 185.987 260.151 186.401 259.088 186.418H157.467C156.959 186.419 156.457 186.316 155.992 186.115C155.526 185.914 155.107 185.62 154.759 185.25C154.412 184.88 154.145 184.443 153.973 183.966C153.802 183.488 153.731 182.981 153.764 182.475L162.046 48.9653C162.129 47.904 162.605 46.912 163.382 46.1836C164.158 45.4552 165.178 45.043 166.243 45.0278Z",
					fill: "black"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M163.91 45.0278H265.525C266.033 45.0213 266.537 45.1205 267.005 45.3192C267.473 45.5179 267.894 45.8117 268.242 46.182C268.59 46.5522 268.858 46.9909 269.027 47.47C269.197 47.9492 269.265 48.4584 269.228 48.9653L260.939 182.475C260.859 183.537 260.385 184.53 259.609 185.26C258.834 185.99 257.813 186.403 256.749 186.418H155.134C154.627 186.419 154.125 186.316 153.659 186.115C153.193 185.914 152.774 185.62 152.427 185.25C152.079 184.88 151.812 184.443 151.641 183.966C151.469 183.488 151.398 182.981 151.431 182.475L159.713 48.9653C159.795 47.9035 160.271 46.9106 161.047 46.182C161.824 45.4533 162.845 45.0416 163.91 45.0278Z",
					fill: "#407BFF"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .4,
					d: "M156.942 179.21L255.854 180.395L263.877 51.0882H164.891L156.942 179.21Z",
					fill: "black"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M154.054 177.901H254.243C259.76 127.35 261.458 100.059 262.211 49.5329H162.021C161.269 100.059 159.578 127.35 154.054 177.901Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsxs("g", {
					opacity: .3,
					children: [
						/* @__PURE__ */ _jsx("path", {
							d: "M234.562 94.7329L226.274 94.6544C225.692 94.658 225.133 94.8786 224.706 95.273C224.278 95.6674 224.014 96.2072 223.964 96.7865C223.941 97.0638 223.975 97.3428 224.066 97.606C224.156 97.8691 224.299 98.1107 224.488 98.3155C224.676 98.5203 224.905 98.6838 225.16 98.7957C225.414 98.9076 225.689 98.9655 225.968 98.9656L234.256 99.0441C234.838 99.039 235.397 98.8171 235.824 98.4217C236.251 98.0262 236.516 97.4858 236.566 96.9058C236.589 96.6289 236.554 96.3501 236.464 96.0873C236.374 95.8244 236.23 95.5832 236.041 95.3789C235.853 95.1746 235.624 95.0117 235.369 94.9005C235.115 94.7893 234.84 94.7322 234.562 94.7329Z",
							fill: "#407BFF"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M237.604 156.128L173.86 155.525C173.279 155.528 172.72 155.749 172.292 156.143C171.865 156.538 171.601 157.078 171.55 157.657C171.527 157.934 171.562 158.213 171.652 158.476C171.742 158.738 171.886 158.98 172.075 159.184C172.263 159.388 172.492 159.551 172.747 159.662C173.001 159.774 173.276 159.831 173.554 159.83L237.291 160.433C237.874 160.432 238.434 160.213 238.862 159.818C239.29 159.423 239.554 158.882 239.601 158.301C239.624 158.025 239.59 157.746 239.5 157.484C239.41 157.222 239.267 156.981 239.079 156.776C238.891 156.572 238.663 156.409 238.409 156.298C238.155 156.186 237.881 156.128 237.604 156.128Z",
							fill: "#407BFF"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M230.825 147.238L174.512 146.705C173.93 146.709 173.371 146.929 172.944 147.324C172.516 147.718 172.252 148.258 172.202 148.837C172.178 149.114 172.212 149.393 172.301 149.656C172.391 149.92 172.534 150.161 172.722 150.366C172.909 150.571 173.138 150.735 173.392 150.847C173.647 150.959 173.921 151.016 174.199 151.016L230.5 151.549C231.082 151.546 231.642 151.324 232.07 150.929C232.497 150.533 232.761 149.992 232.81 149.411C232.833 149.136 232.799 148.859 232.71 148.597C232.621 148.335 232.478 148.095 232.292 147.891C232.106 147.687 231.879 147.524 231.626 147.411C231.374 147.299 231.101 147.24 230.825 147.238Z",
							fill: "#407BFF"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M239.802 125.364L176.059 124.761C175.781 124.76 175.507 124.703 175.253 124.591C174.999 124.48 174.771 124.316 174.583 124.112C174.396 123.908 174.252 123.667 174.162 123.405C174.072 123.142 174.038 122.864 174.061 122.588C174.111 122.008 174.376 121.469 174.803 121.074C175.23 120.68 175.79 120.459 176.371 120.456L240.114 121.059C240.392 121.059 240.666 121.117 240.92 121.228C241.174 121.34 241.402 121.503 241.59 121.707C241.777 121.911 241.921 122.152 242.011 122.415C242.1 122.677 242.135 122.955 242.112 123.232C242.062 123.811 241.797 124.351 241.37 124.745C240.943 125.14 240.383 125.36 239.802 125.364Z",
							fill: "#407BFF"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M231.745 134.113L175.407 133.58C175.13 133.581 174.854 133.524 174.6 133.413C174.345 133.301 174.116 133.138 173.928 132.934C173.739 132.73 173.596 132.489 173.505 132.226C173.415 131.963 173.38 131.684 173.404 131.407C173.452 130.827 173.716 130.285 174.144 129.89C174.571 129.494 175.131 129.273 175.714 129.269L232.051 129.802C232.33 129.801 232.605 129.859 232.86 129.97C233.116 130.082 233.345 130.245 233.533 130.45C233.722 130.655 233.865 130.897 233.955 131.161C234.045 131.424 234.079 131.704 234.055 131.981C234.005 132.561 233.74 133.1 233.313 133.495C232.886 133.889 232.327 134.11 231.745 134.113Z",
							fill: "#407BFF"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M241.359 103.623L177.616 103.02C177.035 103.023 176.475 103.244 176.048 103.638C175.621 104.033 175.356 104.572 175.306 105.152C175.283 105.429 175.318 105.707 175.408 105.97C175.498 106.233 175.642 106.474 175.83 106.679C176.019 106.883 176.248 107.046 176.502 107.157C176.757 107.268 177.032 107.325 177.31 107.325L241.072 107.928C241.653 107.925 242.212 107.704 242.64 107.31C243.067 106.915 243.332 106.375 243.382 105.796C243.405 105.517 243.37 105.237 243.279 104.973C243.187 104.709 243.042 104.467 242.851 104.262C242.661 104.057 242.43 103.895 242.173 103.785C241.916 103.675 241.639 103.62 241.359 103.623Z",
							fill: "#407BFF"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M218.646 94.5822L178.249 94.1998C177.667 94.2034 177.108 94.424 176.681 94.8184C176.254 95.2128 175.989 95.7526 175.939 96.3319C175.916 96.6092 175.95 96.8882 176.041 97.1513C176.131 97.4145 176.275 97.6561 176.463 97.8609C176.651 98.0657 176.88 98.2292 177.135 98.3411C177.389 98.453 177.665 98.5109 177.943 98.511L218.321 98.8932C218.904 98.8881 219.463 98.6662 219.89 98.2708C220.317 97.8754 220.581 97.3349 220.631 96.7549C220.654 96.4796 220.62 96.2024 220.531 95.9408C220.442 95.6793 220.3 95.4389 220.113 95.2349C219.927 95.0309 219.7 94.8676 219.448 94.7553C219.195 94.643 218.922 94.5841 218.646 94.5822Z",
							fill: "#407BFF"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M243.213 77.3669L179.469 76.7636C178.888 76.7671 178.329 76.9877 177.901 77.3821C177.474 77.7766 177.209 78.3163 177.159 78.8957C177.136 79.1729 177.171 79.4519 177.261 79.7151C177.351 79.9783 177.495 80.2199 177.683 80.4247C177.872 80.6294 178.1 80.7929 178.355 80.9048C178.61 81.0167 178.885 81.0746 179.163 81.0748L242.931 81.6784C243.514 81.6747 244.074 81.4532 244.501 81.0575C244.928 80.6618 245.192 80.1206 245.241 79.5401C245.264 79.261 245.229 78.9802 245.137 78.7156C245.046 78.451 244.9 78.2085 244.709 78.0038C244.517 77.7991 244.286 77.6367 244.028 77.527C243.77 77.4173 243.493 77.3628 243.213 77.3669Z",
							fill: "#407BFF"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M236.44 68.4771L180.127 67.9441C179.545 67.9491 178.985 68.1711 178.558 68.5665C178.131 68.9619 177.867 69.5024 177.817 70.0823C177.794 70.3593 177.828 70.638 177.919 70.9009C178.009 71.1637 178.153 71.405 178.341 71.6093C178.529 71.8136 178.758 71.9765 179.013 72.0877C179.268 72.1989 179.543 72.256 179.821 72.2553L236.134 72.7883C236.715 72.7848 237.274 72.5642 237.702 72.1697C238.129 71.7753 238.393 71.2356 238.444 70.6562C238.467 70.379 238.432 70.1 238.342 69.8368C238.252 69.5736 238.108 69.332 237.92 69.1272C237.731 68.9224 237.503 68.7589 237.248 68.647C236.993 68.5351 236.718 68.4773 236.44 68.4771Z",
							fill: "#407BFF"
						})
					]
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .4,
					d: "M226.823 52.5693H228.674C229.17 52.5742 229.662 52.4813 230.122 52.296C230.582 52.1107 231.001 51.8366 231.356 51.4893C231.71 51.142 231.992 50.7283 232.186 50.272C232.381 49.8156 232.483 49.3254 232.488 48.8293V45.3856C232.488 45.3356 232.478 45.2862 232.459 45.2401C232.439 45.194 232.411 45.1522 232.376 45.1172C232.34 45.0822 232.298 45.0546 232.251 45.036C232.205 45.0175 232.155 45.0083 232.105 45.0091H226.872C226.759 45.0107 226.652 45.0561 226.573 45.1356C226.493 45.2152 226.448 45.3225 226.446 45.435L226.471 52.1928C226.471 52.2886 226.507 52.3808 226.572 52.4507C226.637 52.5206 226.727 52.563 226.823 52.5693Z",
					fill: "black"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M198.421 38.7821H229.933C230.384 38.7693 230.831 38.8565 231.243 39.0375C231.656 39.2186 232.023 39.4889 232.318 39.829C232.613 40.1691 232.829 40.5704 232.95 41.0041C233.072 41.4378 233.095 41.8931 233.019 42.3369L232.075 49.354C231.922 50.3239 231.434 51.2098 230.698 51.8588C229.961 52.5078 229.02 52.8792 228.039 52.9088H196.514C196.064 52.9217 195.617 52.8345 195.205 52.6534C194.792 52.4724 194.425 52.2021 194.13 51.862C193.835 51.5219 193.619 51.1205 193.497 50.6868C193.376 50.2531 193.353 49.7979 193.429 49.354L194.379 42.3369C194.533 41.366 195.021 40.4793 195.759 39.8302C196.497 39.1811 197.439 38.8103 198.421 38.7821Z",
					fill: "#407BFF"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .6,
					d: "M198.421 38.7821H229.933C230.384 38.7693 230.831 38.8565 231.243 39.0375C231.656 39.2186 232.023 39.4889 232.318 39.829C232.613 40.1691 232.829 40.5704 232.95 41.0041C233.072 41.4378 233.095 41.8931 233.019 42.3369L232.075 49.354C231.922 50.3239 231.434 51.2098 230.698 51.8588C229.961 52.5078 229.02 52.8792 228.039 52.9088H196.514C196.064 52.9217 195.617 52.8345 195.205 52.6534C194.792 52.4724 194.425 52.2021 194.13 51.862C193.835 51.5219 193.619 51.1205 193.497 50.6868C193.376 50.2531 193.353 49.7979 193.429 49.354L194.379 42.3369C194.533 41.366 195.021 40.4793 195.759 39.8302C196.497 39.1811 197.439 38.8103 198.421 38.7821Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .5,
					d: "M229.119 42.1766H214.924C214.792 42.1872 214.66 42.1705 214.535 42.1273C214.41 42.0842 214.296 42.0157 214.199 41.9262C214.101 41.8366 214.024 41.7279 213.971 41.6069C213.918 41.4859 213.891 41.3552 213.891 41.2231C213.891 41.091 213.918 40.9604 213.971 40.8394C214.024 40.7184 214.101 40.6097 214.199 40.5201C214.296 40.4305 214.41 40.362 214.535 40.3189C214.66 40.2758 214.792 40.259 214.924 40.2696H229.119C229.358 40.2889 229.582 40.3977 229.745 40.5744C229.908 40.7511 229.998 40.9827 229.998 41.2231C229.998 41.4635 229.908 41.6951 229.745 41.8718C229.582 42.0485 229.358 42.1573 229.119 42.1766Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .5,
					d: "M210.203 42.1766H208.709C208.578 42.1872 208.445 42.1705 208.32 42.1273C208.196 42.0842 208.081 42.0157 207.984 41.9262C207.887 41.8366 207.809 41.7279 207.756 41.6069C207.703 41.4859 207.676 41.3552 207.676 41.2231C207.676 41.091 207.703 40.9604 207.756 40.8394C207.809 40.7184 207.887 40.6097 207.984 40.5201C208.081 40.4305 208.196 40.362 208.32 40.3189C208.445 40.2758 208.578 40.259 208.709 40.2696H210.203C210.335 40.259 210.467 40.2758 210.592 40.3189C210.717 40.362 210.831 40.4305 210.928 40.5201C211.025 40.6097 211.103 40.7184 211.156 40.8394C211.209 40.9604 211.236 41.091 211.236 41.2231C211.236 41.3552 211.209 41.4859 211.156 41.6069C211.103 41.7279 211.025 41.8366 210.928 41.9262C210.831 42.0157 210.717 42.0842 210.592 42.1273C210.467 42.1705 210.335 42.1872 210.203 42.1766Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M276.343 28.1947C278.826 21.3518 276.852 16.4749 270.776 16.4749C266.969 16.4749 262.25 18.3972 257.651 21.5156C257.133 19.7352 255.668 18.6703 253.313 18.6703C249.172 18.6703 243.464 21.9471 238.985 26.6164C237.902 25.5842 236.334 24.9453 234.318 24.847C230.361 24.634 225.556 26.529 221.368 29.6146C220.872 29.0212 220.211 28.703 219.531 28.7299C217.244 28.6098 214.153 30.5212 212.62 32.9952C212.521 33.1535 212.436 33.301 212.354 33.4539H279.426C281.546 31.0182 279.203 28.3149 276.343 28.1947Z",
					fill: "#F5F5F5"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M222.645 10.4725C222.402 10.446 222.158 10.4332 221.914 10.4343C222.138 7.89478 220.821 6.27279 218.014 6.27279C215.983 6.27279 213.498 7.11928 210.964 8.55013C211.685 3.63501 209.364 0.418335 204.105 0.418335C199.861 0.418335 194.487 2.50453 189.179 5.87958C188.715 3.9463 187.147 2.78851 184.521 2.78851C179.906 2.78851 173.347 6.36563 168.088 11.4173C166.952 10.2923 165.248 9.59869 163.003 9.484C158.607 9.26009 153.173 11.3135 148.312 14.6667C148.083 14.3557 147.781 14.1054 147.432 13.9379C147.084 13.7704 146.7 13.6906 146.314 13.7055C143.911 13.5799 140.601 15.4313 138.668 17.9052H226.512C228.576 14.1752 226.933 10.893 222.645 10.4725Z",
					fill: "#F5F5F5"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 317.845,
				height: 186,
				fill: "white",
				transform: "translate(0.577637 0.418335)"
			})
		}), /* @__PURE__ */ _jsx("clipPath", {
			id: "clip1",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 317.845,
				height: 151.277,
				fill: "white",
				transform: "translate(0.577637 28.4184)"
			})
		})] })
	]
});
const ForwardRef = forwardRef(SvgQuickCalculatorStep4);
export default ForwardRef;
